import { Button, Display } from 'Views/Components/Button/Button';
import { observer, useLocalStore } from 'mobx-react';

import ButtonAsyncState from 'Views/Components/Button/ButtonAsyncState';
import FileUpload from 'Views/Components/FileUpload/FileUpload';
import Modal from 'Views/Components/Modal/Modal';
import React from 'react';
import { SERVER_URL } from 'Constants';
import { Tooltip } from 'Views/Components/Tooltip/Tooltip';
import alertToast from 'Util/ToastifyUtils';
import axios from 'axios';

interface Props {
    reportRequestId: string;
	onClose: () => void;
}

async function uploadCreditReport(file: File, reportRequestId: string): Promise<void> {
	const url = `${SERVER_URL}/api/credit-report/upload`;

	const formData = new FormData();
	formData.append('reportRequestId', reportRequestId);
	formData.append('creditReportFile', file);

	await axios.post(url, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
}

const CreditReportUploadModal: React.FunctionComponent<Props> = observer(({ reportRequestId, onClose }) => {
	const modalState = useLocalStore(() => ({
		file: undefined as File | undefined,
	}));

	async function handleUpload() {
		try {
			await uploadCreditReport(modalState.file!, reportRequestId);
			alertToast('Successfully uploaded Credit Report file', 'success');
		} catch (error) {
			alertToast('Failed to upload Credit Report file', 'error');
		}
		onClose();
	}

	return (
		<Modal
			isOpen
			label="Upload Credit Report"
			onRequestClose={onClose}
			className="upload-ato-debt-modal"
		>
			<div>
				<h4>
					Upload file
					<Tooltip
						id="upload-credit-report-tooltip"
						content="Upload a manually generated credit report, and set the report request to 'Completed'."
						place="right"
					/>
				</h4>
			</div>
			<FileUpload
				model={modalState}
				modelProperty="file"
				label="Credit Report File"
				labelVisible
				contentType="application/pdf"
				preview
				onDelete={() => {
					modalState.file = undefined;
				}}
			/>

			<div key="actions" className="modal__actions">
				<Button key="cancel" onClick={onClose} display={Display.Outline}>Cancel</Button>
				<ButtonAsyncState
					key="confirm"
					onPress={() => handleUpload()}
					display={Display.Solid}
					readonly={!modalState.file}
					waitingText="Uploading..."
				>
					Upload Credit Report
				</ButtonAsyncState>
			</div>
		</Modal>
	);
});

export default CreditReportUploadModal;